import { HttpBulkUploadService } from './../../../service/http-bulk-upload.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BulkUploadDto, BulkUploadFileCellDto, BulkUploadFileDto, BulkUploadFileLineDto, ResultListDto } from '../../../service/dto';

@Component({
	selector: 'app-member-bulk-upload-view',
	standalone: false,
	templateUrl: './member-bulk-upload-view.component.html',
	styleUrl: './member-bulk-upload-view.component.scss'
})
export class MemberBulkUploadViewComponent implements OnInit {
	bulkUpload?: BulkUploadDto;
	currentFile?: BulkUploadFileDto;

	currentFileRows?: ResultListDto<BulkUploadFileLineDto>;
	pageIndex = 1;
	pageSize = 100;
	showOnlyFailed = false;
	showOnlyMapped = false;

	constructor(private route: ActivatedRoute, private service: HttpBulkUploadService) { }

	ngOnInit(): void {
		const id = +this.route.snapshot.paramMap.get('id')!;
		this.load(id);
	}

	load(id: number): void {
		this.service.get(id).subscribe(result => {
			this.bulkUpload = result;
			this.onTab(0);
		});
	}

	onTab(index: number): void {
		this.currentFile = this.bulkUpload!.files![index];
		this.pageIndex = 0;
		this.loadFileData();
	}

	onPageChange(newIndex: number): void {
		this.pageIndex = newIndex;
		this.loadFileData();
	}

	onPageSizeChange(newSize: number): void {
		this.pageSize = newSize;
		this.loadFileData();
	}

	loadFileData(): void {
		this.service.getFileContents(this.currentFile!.id!, this.showOnlyFailed, this.pageIndex, this.pageSize)
			.subscribe(result => {
				this.currentFileRows = result;
			});
	}

	goBack(): void {
		history.back();
	}

	statusColor(status?: string): string {
		switch (status) {
			case 'COMPLETED': return 'green';
			case 'FAILED': return 'red';
			case 'PROCESSING': return 'blue';
			default: return 'default';
		}
	}
	getRowStyle(input: BulkUploadFileLineDto) {
		if (input.status == 'Failed') {
			return 'table-danger';
		}
		if (input.status == 'Invalid') {
			return 'table-danger';
		}
		// if(input.status == 'Inserted'){
		// 	return 'table-success';
		// }
		// if(input.status == 'Updated'){
		// 	return 'table-info';
		// }
		return undefined;
	}
	getCellStyle(input: BulkUploadFileCellDto) {
		if (!input.valid && input.propertyId) {
			return 'table-danger';
		}
		return undefined;
	}
}
